export const LOADING_DATA="LOADING_DATA";
export const SUCCESSED_DATA="SUCCESSED_DATA";
export const FAILED_DATA="FAILED_DATA";
export const LOADING_STAMP="LOADING_STAMP";
export const SUCCESSED_STAMP="SUCCESSED_STAMP";
export const FAILED_STAMP="FAILED_STAMP";
export const RESET_LOADED_DATA="RESET_LOADED_DATA";
export const RESET_LOADED_STAMP="RESET_LOADED_STAMP";